import {useHistory, useParams} from 'react-router-dom';
import styled from "styled-components";
import {Tag} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {Calendar, Mail} from "lucide-react";
import Main from '../../../components/main';
import CommunityHeader from "../../../components/community_header";
import {useBottomBar} from "../../../app_context";
import {useBaseCommunity, useLoggedIn, useStoreProfile} from '../../../store';
import {formatDate} from "../../../utils/calendar";
import {useCommunityReportReasons} from "../../../api/report_reasons";
import useFeedback from "../../../utils/use_feedback";
import {useCommunities, useModeratorList} from "../../../api/communities";
import NavLink from "../../../components/nav_link";
import useModal from "../../../modals";
import Sheet from "../../../components/bottom-sheet/sheet";
import SignupPromptSheet from "../../../components/bottom-sheet/signup_prompt";
import {useSheetModal} from "../../../components/test/ModalContext";
import {themecolors} from "../../../utils/themecolors";
import {FadedTopBar} from "../../../components/top_bar";

const About = styled.div``;
const Topics = styled.div``;
const Heading = styled.div``;
const Message = styled.div``;
const Created = styled.div``;

const Moderator = styled.div``;
const ModeratorList = styled(({moderators, className}) => {
    return (
        <div className={className}>
            {moderators.map((moderator) => (
                <Moderator key={moderator.author}>
                    <NavLink href={`/u/${moderator.author}`}>
                        {moderator.author}
                    </NavLink>
                </Moderator>
            ))}
        </div>
    );
})`
  color: ${({theme}) => theme.menu.color};
  padding-bottom: 72px;
  ${Moderator} {
    display: flex;
    padding: 2px 0;
    font-size: 14px;
  }
`;

const AboutCommunity = styled(({className}) => {

    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const {feedbackCh} = useFeedback();
    const communityInfo = useCommunities(feedbackCh, [paramsCommunity])[0] || false;
    const created = formatDate(communityInfo.created ? communityInfo.created : 0);
    const rules = useCommunityReportReasons(feedbackCh, community)?.rules;
    const moderators = useModeratorList(feedbackCh, community);
    useBottomBar();

    const loggedIn = useLoggedIn();
    const history = useHistory();
    const modal = useModal();

    const {moderates} = useStoreProfile();

    const { openModal } = useSheetModal();

    const handleMessage = () => {

        if (loggedIn) {
            history.push(`/send?to=c:${communityInfo.name}`);
        } else {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }

    };

    const [offset, setOffset] = useState(0);
    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        //window.history.scrollRestoration = 'manual';
    }, []);

    return (
        <>
            <FadedTopBar active={offset > 44} search community={community} sidebar={false} settings
                         style={{position: 'fixed'}} feedTitle={community.display_name || community} back
                         modTools={moderates.includes(community.name)}/>
            <div style={{paddingTop: '50px'}} />
            <CommunityHeader community={communityInfo} pageType={'About'}/>
            <Main>
                <About className={className}>
                    <p>
                        {communityInfo?.description || "No description provided."}
                    </p>
                    <Topics>
                        {communityInfo?.topics?.map((topic) => (
                            <Tag variant="topic" key={topic}>{topic}</Tag>
                        ))}
                    </Topics>
                    <Created>
                        <Calendar size={16} />
                        <div style={{marginLeft: '6px'}}> Created {created}</div>
                    </Created>
                    <Heading>Moderators <Message onClick={handleMessage}><Mail size={16} /></Message></Heading>
                    {moderators && (
                        <ModeratorList moderators={moderators} />
                    )}
                </About>
            </Main>
        </>
    );
})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? 'none' : theme.white_0};
  margin-top: 16px;
  padding: 0 20px;
  padding-bottom: 16px;

  ${Heading} {
    display: flex;
    align-items: center;
    padding-top: 16px;
    padding-bottom: 12px;
    font-size: 15px;
    font-weight: 600;
  }

  ${Heading} ${Message} {
    margin-left: auto;
    cursor: pointer;
  }

  p {
    font-size: 14px;
  }

  svg {
    margin-right: 4px;
  }

  ${Topics} > * {
    margin-right: 4px;
    margin-bottom: 4px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : 'rgba(0, 0, 0, .05)'};
  }

  ${Topics} {
    margin: 12px 0;
  }

  ${Created} {
    display: flex;
    align-items: center;
  }
`;

export default AboutCommunity;
